import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SnackBarContext } from "../../context/SnackBarContext";
import { fetchCompanyData } from "../../redux/slice/CompanySlice/CompanySlice";
import { DeleteCompanyApi } from "../../Apis/Companies/CompaniesApis";
import AppConfirmationDialog from "../../components/ConfirmationDialog/ConfirmationDialog";
import Loader from "../../components/Loader/Loader";
import CompaniesDetailDialog from "../../components/Companies/CompaniesDetailDialog/CompaniesDetailDialog";
import { MdDelete } from "react-icons/md";
import { Dropdown } from "react-bootstrap";

function Companies() {
  const [alldata, setalldata] = useState([]);
  const [rows, setrows] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedRow, setSelectedRow] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [loading, setLoading] = useState(false);
  const { setsnackBarData } = useContext(SnackBarContext);
  const [filterText, setFilterText] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [showCompanyDetails, setShowCompanyDetail] = useState(false);

  const { CompanyData, status } = useSelector((state) => state?.Companies);

  useEffect(() => {
    dispatch(fetchCompanyData());
  }, [dispatch]);

  useEffect(() => {
    setalldata(CompanyData || []);
  }, [CompanyData]);

  const deleteCompany = async () => {
    setLoading(true);
    setShowConfirmation(false);
    const response = await DeleteCompanyApi(selectedRow?.id);
    response?.snackBarData?.message && setsnackBarData(response?.snackBarData);
    if (response?.success) {
      dispatch(fetchCompanyData());
      setSelectedRow(null);
    }
    setLoading(false);
  };

  useEffect(() => {
    const arr =
      alldata?.map((item, idx) => ({
        id: idx + 1,
        ...item,
      })) || [];
    setrows(arr);
  }, [alldata]);

  useEffect(() => {
    setFilteredData(rows || []);
  }, [rows]);

  const handleFilterChange = (event) => {
    const value = event.target.value.toLowerCase();
    setFilterText(value);
    const filtered = alldata.filter(
      (item) =>
        item.companyName.toLowerCase().includes(value) ||
        item.email.toLowerCase().includes(value) ||
        item.phoneNumber.toLowerCase().includes(value)
    );
    setFilteredData(filtered);
  };

  return (
    <>
      <div className="companies-container  ">
        {/* Search + New button */}
        <div className="companies-header d-flex justify-content-between align-items-center mb-4 gap-3 flex-wrap">
          <input
            type="text"
            className="form-control search-input"
            placeholder="Search By Name, Email or Phone"
            value={filterText}
            onChange={handleFilterChange}
          />
          <div className="d-flex gap-4">
            <button
              className="btn btn-primary new-btn"
              onClick={() => navigate("/companies/form")}
            >
              New
            </button>

          </div>

        </div>


        {/* Cards */}
        <div className="row g-3 dark-panel">
          {filteredData?.map((company, idx) => (
            <div
              className="col-12 col-sm-6 col-md-4 col-lg-3 "
              key={idx}
            >
              <div className="card  text-center rounded-3 p-3 h-100 shadow-sm ">
                <div className="d-flex justify-content-end ">
                  <Dropdown>
                    <Dropdown.Toggle
                      as="div"
                      className="p-0 custom-dropdown-toggle"
                      style={{ cursor: "pointer" }}
                    >
                      <i className="bi bi-three-dots-vertical fs-5"></i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="dropdown-menu-end">
                      <Dropdown.Item
                        onClick={() =>
                          navigate("/companies/form", { state: company })
                        }
                      >
                        <i className="bi bi-pencil-fill text-info me-2"></i>
                        Edit
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => {
                          setShowCompanyDetail(true);
                          setSelectedRow(company);
                        }}
                      >
                        <i className="bi bi-eye-fill text-warning me-2"></i>
                        View Details
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() =>
                          navigate("/companies/equipment-view", { state: company })
                        }
                      >
                        <i className="bi bi-gear-fill text-primary me-2"></i>
                        Equipment Cut
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>

                {/* Company Image */}
                {company?.profileImage ? (
                  <div className="company-logo-container">
                    <img
                      src={company?.profileImage}
                      alt="Company Logo"
                      className="company-logo"
                    />
                  </div>

                ) : (
                  <div className="placeholder-logo bg-secondary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto">
                    Logo
                  </div>
                )}

                {/* Company Name */}
                <h5 className="mt-3 text-truncate px-2">{company.companyName}</h5>
              </div>
            </div>
          ))}
        </div>

        {/* Modals */}
        {showConfirmation && (
          <AppConfirmationDialog
            open={showConfirmation}
            onDeny={() => {
              setSelectedRow(null);
              setShowConfirmation(false);
            }}
            onConfirm={deleteCompany}
            iconContainerColor="#fbeaea"
            icon={<MdDelete fontSize="small" color="red" />}
            dialogTitle="Delete Company"
            title={`Are you sure, you want to delete company ${selectedRow?.name}?`}
            successText="Yes"
            successBtnColor="error"
            cancelText="No"
          />
        )}

        {status === "loading" || loading ? <Loader /> : null}

        {showCompanyDetails && (
          <CompaniesDetailDialog
            open={showCompanyDetails}
            onClose={() => {
              setSelectedRow(null);
              setShowCompanyDetail(false);
            }}
            state={selectedRow}
          />
        )}
      </div>
    </>
  );
}

export default Companies;
